import { gunAraligiMetni } from "@koclukpanel/ui";

/**
 * ================================================================
 * VELİ ÖZETİNİN HAFTA ARALIĞI — "Bu hafta" HANGİ HAFTA?
 * ================================================================
 * `VeliPortali.tsx` başlığı elle **"Bu hafta"** yazıyordu ve hangi
 * hafta olduğunu hiç söylemiyordu. Sunucu ise sınırları zaten
 * gönderiyor (`VeliOzet.hafta.basi/sonu`) — yani bilgi teldeydi,
 * ekranda yoktu.
 *
 * Velinin bakış açısından fark somut: Pazartesi sabahı açan veli
 * "bu hafta" derken **yeni** haftayı görüyor ve rakamlar sıfıra
 * yakın; Pazar akşamı açan **biten** haftayı görüyor. İkisi de
 * "Bu hafta" yazıyor. Rakamların hangi yedi güne ait olduğu
 * söylenmezse veli onları yanlış haftaya yorabilir — ve çocuğu
 * hakkında yanlış bir sonuç çıkarır.
 *
 * ================================================================
 * 🔴 `toLocaleDateString` BURADA YANLIŞ OLURDU — ÖLÇÜLDÜ
 * ================================================================
 * Panelde yaygın kalıp `new Date(x).toLocaleDateString("tr-TR")` ve o
 * kalıp **kendi yerinde doğru**: `createdAt` gibi alanlar gerçek bir
 * ANI taşır, yerel saate çevrilmeleri gerekir.
 *
 * Hafta sınırları öyle değil. `packages/contracts/src/zaman.ts` →
 * `yerelGunBasi` bir tarihi **UTC gece yarısı damgalı** üretiyor ve o
 * damganın UTC bileşenleri **Istanbul takvim gününü** taşıyor
 * (`haftaSonu` de `setUTCDate(+6)` ile aynı biçimi koruyor).
 *
 * Yani `2026-09-01T00:00:00.000Z` "1 Eylül" DEMEK — bir an değil, bir
 * takvim günü. Bunu yerel saate çevirmek, UTC'nin gerisindeki bir saat
 * diliminde günü **bir gün geriye** kaydırır: 31 Ağustos yazar.
 *
 * Bu, bu depoda C14.1 olarak kayıtlı "gece yarısı sınıfı"nın ta
 * kendisi ve düzeltmesi `zaman.ts`in kendi yorumunda yazılı:
 * *"Saklanmış bir tarihi buradan geçirmek onu bir gün GERİ atardı —
 * yani körü körüne düzeltme yeni bir hata olurdu."*
 *
 * Bu yüzden biçimlendirme `timeZone: "UTC"` ile yapılıyor. Tarayıcının
 * saat dilimi ne olursa olsun ekranda sunucunun kastettiği gün
 * görünüyor.
 *
 * **Genel kural:** bir alan ANI mı yoksa TAKVİM GÜNÜ mü taşıyor?
 * Anlar yerele çevrilir, takvim günleri çevrilmez. İkisi aynı tipte
 * (`string`/`Date`) göründüğü için ayrım koda değil **anlama** bağlı
 * ve bu yüzden yazılı olmak zorunda.
 */

/*
  BİÇİMLENDİRİCİ ARTIK ORTAK — UI/UX Dalga 1 (K7). Mantık (çağrı başına
  kurulan `Intl`, `timeZone: "UTC"`, en kısa aralık biçimi) aynen
  `packages/ui/src/tarih-bicimi.ts` içine taşındı ve panelin program
  başlığı da onu kullanıyor. Bu dosyanın testleri sözleşmeyi korumaya
  devam ediyor: veli özeti yılı HER ZAMAN yazar.
*/
/**
 * "1 – 7 Eylül 2026" · "29 Eylül – 5 Ekim 2026" ·
 * "29 Aralık 2026 – 4 Ocak 2027"
 *
 * Tekrarı olmayan en kısa biçim seçiliyor: ay aynıysa ay bir kez, yıl
 * aynıysa yıl bir kez yazılıyor. Uzun biçim ("1 Eylül 2026 – 7 Eylül
 * 2026") yanlış değil ama başlıkta okunmaz — ve okunmayan bir başlık,
 * olmayan başlıktan farksız.
 *
 * Çözülemeyen değerde `null` döner: **uydurma yok.** Ekran o zaman
 * sadece "Bu hafta" yazar, çünkü yanlış bir tarih aralığı hiç tarih
 * olmamasından kötüdür.
 */
export function haftaAraligi(basiIso: string, sonuIso: string): string | null {
  return gunAraligiMetni(basiIso, sonuIso, { yil: "her-zaman" });
}
